module.exports = __webpack_public_path__ + "static/media/logo-welearn-bg-white.e99808d6.svg";